module.exports = __webpack_public_path__ + "static/media/three_monkey_lift_wood.b0faabb8.png";